import { faIdCard, faStar } from '@fortawesome/free-solid-svg-icons';

export const SUBSCRIPTION_TYPES = {
  SUBSCRIPTION: 'subscription',
  MEMBERSHIP: 'membership',
};

export const SUBSCRIPTION_TYPES_UA = {
  [SUBSCRIPTION_TYPES.SUBSCRIPTION]: 'Абонемент',
  [SUBSCRIPTION_TYPES.MEMBERSHIP]: 'Членство',
};

export const SUBSCRIPTION_TYPES_ICONS = {
  [SUBSCRIPTION_TYPES.SUBSCRIPTION]: faIdCard,
  [SUBSCRIPTION_TYPES.MEMBERSHIP]: faStar,
};
